import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Modal, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import React, { useState } from "react";
import {
  sxSubTitle,
  sxSubTitleSmall,
} from "../../../../assets/styles/CommonSxProps";
import { TermoFinalizacaoModalProps } from "../../../../interfaces/entities/Reembolso/TermoFinalizacaoModalProps";
import "./styles.css";
import {
  sxButton,
  sxCheckbox,
  sxError,
  sxOutlinedButton,
  sxTermsOfUseModal,
} from "./sxProps";

function TermoFinalizacaoModal(props: TermoFinalizacaoModalProps) {
  const [acceptSharing, setAcceptSharing] = useState<boolean>(false);
  const [acceptOtherOperator, setacceptOtherOperator] =
    useState<boolean>(false);
  const [errorSharing, setErrorSharing] = useState<boolean>();
  const [errorOtherOperator, setErrorOtherOperator] = useState<boolean>();
  const textosTermos: string[] = props.textoTermos.split("\n");

  const handleAgreedSharing = (event: React.ChangeEvent<HTMLInputElement>) => {
    setErrorSharing(false);
    setAcceptSharing(event.target.checked);
  };

  const handleAgreedOtherOperator = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setErrorOtherOperator(false);
    setacceptOtherOperator(event.target.checked);
  };

  const handleCloseModal = () => {
    setAcceptSharing(false);
    setacceptOtherOperator(false);
    props.closeTermsOfUse();
  };

  const handleConfirm = async () => {
    if (acceptSharing) {
      if (acceptOtherOperator) {
        props.handleTermsOfUse();
      } else {
        setErrorOtherOperator(true);
      }
    } else {
      setErrorSharing(true);
    }
  };

  const hasError = (index: number) => {
    if (index === 0) {
      return errorSharing;
    } else if (index === 1) {
      return errorOtherOperator;
    }
  };

  return (
    <div>
      <Modal
        open={props.open}
        onClose={() => {}}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={sxTermsOfUseModal}>
          <div className="terms-of-use-holder">
            <div className="terms-of-use-modal-header">
              <Typography component="h2" sx={sxSubTitle}>Termo de Reembolso</Typography>
              <button
                className="terms-of-use-modal-header-close"
                onClick={handleCloseModal}
                aria-label="fechar termo de reembolso"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
            <div className="finalization-terms-holder" id="estou-ciente-label">
              <Typography 
                aria-label="Estou ciente grupo com dois itens" 
                sx={sxSubTitleSmall}>Estou ciente</Typography>
            </div>
            <div className="finalization-terms-checkbox" role="group" aria-labelledby="estou-ciente-label">
              {textosTermos.map((line, index) => (
                <React.Fragment key={index}>
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        onChange={
                          index === 0
                            ? handleAgreedSharing
                            : handleAgreedOtherOperator
                        }
                      />
                    }
                    label={line}
                    sx={sxCheckbox}
                  />
                  {hasError(index) && (
                    <div className="terms-of-use-error-holder">
                      <Typography sx={sxError}>
                        Necessário aceitar os termos para seguir
                      </Typography>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
            <div className="terms-of-use-buttons-holder">
              <div className="terms-of-use-buttons">
                <Button
                  variant="outlined"
                  size="large"
                  onClick={handleCloseModal}
                  sx={sxOutlinedButton}
                  fullWidth
                >
                  <span
                    style={{
                      color: "#00995D",
                    }}
                  >
                    CANCELAR
                  </span>
                </Button>
              </div>
              <div className="terms-of-use-buttons">
                <Button
                  variant="contained"
                  size="large"
                  onClick={handleConfirm}
                  sx={sxButton}
                  disabled={!acceptSharing || !acceptOtherOperator}
                  fullWidth
                >
                  CONFIRMAR
                </Button>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default TermoFinalizacaoModal;
